import { Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import * as d3 from 'd3'

@Component({
  selector: 'risk-bar-graph',
  templateUrl: './risk-bar-graph.component.html'
})
export class RiskBarGraphComponent implements OnChanges {
  idGraph: any = this.commonUtilsService.createId()
  riskBarGraph:any ={
    width: 622,
    height: 0,
    marginTop: 20,
    marginRight: 30,
    marginBottom: 50,
    marginLeft: 300,
    riskLabels: [
      { text: 'RIESGO BAJO', position: 2, color: '#000080' },
      { text: 'RIESGO MEDIO', position: 4, color: '#000080' },
      { text: 'RIESGO ALTO', position: 6, color: '#000080' }
    ],
    nodeSelected:{},
    graphDataAll: []
  }
  constructor( private container: ElementRef,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private translate: AfTranslateFactory
  ) { }

  @Input() graphData:any = [];
  @Input() isModal:boolean = false;


  ngOnChanges(): void {
    this.riskBarGraph.width = this.isModal? 800:622;
    if(this.graphData?.length){
      if(this.graphData?.length > 10){
        this.riskBarGraph.graphDataAll = this.graphData;
      }
      this.riskBarGraph.graphDataToShow = this.isModal? this.graphData : this.graphData.slice(0, 10)
      this.riskBarGraph.height = this.riskBarGraph.graphDataToShow.length * 46 + 25;
      this.createChart();
    }

  }

  private createChart(): void {
    const element = this.container.nativeElement.firstChild.firstChild;
    this.riskBarGraph.svg = d3.select(element)
      .append('svg')
      .attr('height', this.riskBarGraph.height)
      .attr("width", this.riskBarGraph.width);
      // .attr("viewBox", `0 0 ${this.riskBarGraph.width} ${this.riskBarGraph.height}`);

    let g:any = this.riskBarGraph.svg.append('g')
      .attr('class', 'risk-map-graph__group-container')

    this.riskBarGraph.x = d3.scaleLinear()
      .domain([0, 6])
      .range([this.riskBarGraph.marginLeft, this.riskBarGraph.width - this.riskBarGraph.marginRight]);

      this.riskBarGraph.y = d3.scaleBand()
      .domain(this.riskBarGraph.graphDataToShow.map((d:any) =>{return  d.id}))
      .range([this.riskBarGraph.marginTop, this.riskBarGraph.height])
      .padding(0.1);

    g.append('g')
      .attr('transform', `translate(${this.riskBarGraph.marginLeft - 10},0)`)
      .attr('class', 'risk-bar-graph__y-axxis')
      .call(d3.axisLeft(this.riskBarGraph.y).tickSizeOuter(0))

    let gElement: any = g.selectAll('risk-bar-graph__line-container')
      .data(this.riskBarGraph.graphDataToShow);

    let gSplitPie:any =  gElement.enter()
      .append('g')
      .attr('class', 'risk-bar-graph__line-container')
      .attr('transform', `translate(0,0)`);

    gSplitPie.append('foreignObject')
      .attr('x', '0')
      .attr('y', (d:any) =>{return this.riskBarGraph.y(d.id)! - 10})
      .attr('height', '44')
      .attr("width", this.riskBarGraph.marginLeft - 10)
      .append('xhtml:div')
      .attr('class', 'risk-bar-graph__line-label-box')
      .html((d:any)=>{return `<p class="risk-bar-graph__line-label">${d.label}</p>`})


    gSplitPie.append('rect')
      .attr('x', this.riskBarGraph.marginLeft)
      .attr('y', (d:any) =>{return this.riskBarGraph.y(d.id)!})
      .attr('class', 'risk-bar-graph__line')
      .attr('width', (d:any) =>{return this.riskBarGraph.x(d.value) - this.riskBarGraph.marginLeft})
      .attr('height', '20')
      .attr('fill', (d:any) =>{return d.color});

    gSplitPie.append('foreignObject')
      .attr('x', (d:any) =>{return this.riskBarGraph.x(d.value)+ 8})
      .attr('y', (d:any) =>{return this.riskBarGraph.y(d.id)! + 1})
      .attr('height', '20')
      .attr("width", '20')
      .append('xhtml:div')
      .attr('class', 'risk-bar-graph__line-icon')
      .on('click', (ev:any, d:any)=>{ this.showTooltip(d)})

      .html((d:any)=>{
        return d.dependencies[0] !== ''? `<i id="button-${this.idGraph}-${d.id}" class="lf-icon-info-full"></i>`: ``;
      })


      let newMoreElements: any = d3.select('.risk-map-graph__group-container').append('g')
      .attr('class', 'risk-bar-graph__view-more-elements')
      .attr('transform', `translate(0,0)`);

  if(!this.isModal && this.riskBarGraph.graphDataAll.length){
    newMoreElements.append('foreignObject')
      .attr("x", "0")
      .attr('width', '290')
      .attr('y', (d:any)=>{return this.riskBarGraph.y(this.riskBarGraph.graphDataToShow[this.riskBarGraph.graphDataToShow.length - 1].id)! + this.riskBarGraph.marginTop})
      .attr("height", "50")
      .append('xhtml:button')
      .attr("class", 'risk-bar-graph__show-more')
      .text(this.translate.instant('report-graph.show-more-crimes'))
      .on('click', (ev:any, d:any)=>{
        this.showMoreCrimes()
      });
  }


  g.append('foreignObject')
    .attr("x", "300")
    .attr('width', (d:any) =>{
      return  this.riskBarGraph.x(6) - this.riskBarGraph.marginLeft
    })
    .attr('y', (d:any)=>{return this.riskBarGraph.y(this.riskBarGraph.graphDataToShow[this.riskBarGraph.graphDataToShow.length - 1].id)! + this.riskBarGraph.marginTop})
    .attr("height", "50")
    .append('xhtml:ul')
    .attr("class", 'risk-bar-graph__x-ticks-container')
    .html(
      `${this.loadRisksLabels()}`
    )

}

  loadRisksLabels(){
    let html:string= ''
    for(let i: number = 0; i < this.riskBarGraph.riskLabels.length; i++){
      let riskLabel:any = this.riskBarGraph.riskLabels[i].text
      html+=`<li class="risk-bar-graph__x-block">
              <div class="risk-bar-graph__x-block-line ${i === this.riskBarGraph.riskLabels.length-1? 'risk-bar-graph__x-block-line--last' :''}"></div>
              <p class="risk-bar-graph__x-block-text">${riskLabel}</p>
            </li>`
    }
    return html;
  }
  showTooltip(d:any){
    let element: any = this.configurePositionTooltip(d)
    this.riskBarGraph.nodeSelected = d;
    d3.select(`#risk-bar-graph-tooltip-${this.idGraph}`)
      .style('left', `${element.offsetX}px`)
      .style('top', `${element.offsetY}px`)
      .style('visibility', 'visible')

  }

  configurePositionTooltip(d: any){
      let element: any = document.getElementById(`button-${this.idGraph}-${d.id}`);
      let clientRect = element.getBoundingClientRect();
      let clientText = { clientX: clientRect.left, clientY: clientRect.top};
      let widthTooltip: number = this.isModal? 132 : 100;
      let offsetX =  d3.pointer(clientText, this.riskBarGraph.svg.node())[0] - (widthTooltip - (clientRect.width/2));
      let offsetY =  d3.pointer(clientText, this.riskBarGraph.svg.node())[1] + 40;
      return { offsetX: offsetX, offsetY: offsetY };
    }

  closeRiskTooltip(){
    d3.select(`#risk-bar-graph-tooltip-${this.idGraph}`)
      .style('visibility', 'hidden')
  }
  showMoreCrimes(){
    this.modalService.viewExtendedReport(null, this.riskBarGraph.graphDataAll, 'risk');
  }
}
